import React from "react";

// ============================================================
// Iter 86 — FlockGroupTabs
// Four-tab segmented control (Members / Visitors / Guests / All)
// used at the top of The Flock page. The parent (MembersPage)
// computes `visibleTabs` from the viewer's role, attendance
// authority, and visitor assignments. If only one tab is
// visible the control is hidden entirely to reduce noise.
// ============================================================
export function FlockGroupTabs({ active, onChange, visibleTabs = ["members", "visitors", "guests", "all"] }) {
  const ALL_TABS = [
    { key: "members",  label: "Members" },
    { key: "visitors", label: "Visitors" },
    { key: "guests",   label: "Guests" },
    { key: "all",      label: "All" },
  ];
  const TABS = ALL_TABS.filter(t => visibleTabs.includes(t.key));
  // Restricted TMs may only see one tab — hide the segmented control entirely
  // in that case to reduce visual noise.
  if (TABS.length <= 1) return null;
  return (
    <div
      role="tablist"
      data-testid="flock-group-tabs"
      style={{
        display: "inline-flex",
        gap: 2,
        background: "color-mix(in srgb, var(--kc-text) 6%, transparent)",
        padding: 3,
        borderRadius: 999,
        marginBottom: 12,
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      {TABS.map(t => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            data-testid={`flock-group-tab-${t.key}`}
            onClick={() => onChange(t.key)}
            style={{
              padding: "6px 14px",
              borderRadius: 999,
              border: "none",
              cursor: "pointer",
              background: isActive ? "var(--kc-accent)" : "transparent",
              color: isActive ? "#111" : "var(--kc-text)",
              fontFamily: "'Cinzel',serif",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              lineHeight: 1.2,
              transition: "background 160ms ease, color 160ms ease",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
